const MS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;

export function formatDuration(ms: number): string {
    if (ms < MS_IN_SECOND) return `${ms}ms`;
    const s = ms / MS_IN_SECOND;
    if (s < SECONDS_IN_MINUTE) return `${s.toFixed(1)}s`;
    const m = Math.floor(s / SECONDS_IN_MINUTE);
    const rem = (s % SECONDS_IN_MINUTE).toFixed(0);
    return `${m}m ${rem}s`;
}
